import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { User } from '~/http/users/types'

export class UsersAPI extends Http {
  all = (): Promise<User[]> => {
    return this.callAuthWithPropertyAPI<null, User[]>(HttpMethod.GET, { path: APIPaths.USERS })
  }
}

export const useUsersAPI = (): UsersAPI => {
  return new UsersAPI()
}
